module.exports = __webpack_public_path__ + "img/qyy.5572fe98.jpg";